import {Component, Input} from '@angular/core';
import {CourseSection} from '../../models/course-section.model';
import {Lesson} from '../../models/lesson.model';
import {NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {CoursePageData} from '../../course-page/course-page-data.model';

type SectionLessons = {
  [p: string]: { sectionLessons: Lesson[]; sectionStartIndex: number };
};

@Component({
    selector: "stats-info",
    templateUrl: "./stats-info.component.html",
    styleUrls: ["./stats-info.component.scss"],
    imports: [
        NgIf,
        TranslateModule
    ]
})
export class StatsInfoComponent {
  @Input()
  data: CoursePageData

  @Input()
  sections: CourseSection[];

  @Input()
  sectionLessons: SectionLessons;

  getAllLessons() {
    return Object.values(this.sectionLessons).reduce((result, item) => {
      return result.concat(item.sectionLessons);
    }, [])
  }

  getNumberOfSections() {
    const sectionsLength = this.sections.length
    if(sectionsLength <= 0) {
      return 0
    }
    return sectionsLength - 1
  }

  getTotalLessons() {
    const lessonsLength = this.getAllLessons().length
    const lengthToDisplay = lessonsLength - 4
    if(lengthToDisplay <= 0) {
      return 0
    }
    return  lengthToDisplay
  }

}
